import { userConstants } from "../../constant";

const initialState = {
  tracking: null,
};

export function orderTracking(state = initialState, action) {
  switch (action.type) {
    case userConstants.GET_ORDER_TRACKING:
      return { ...state, tracking: action.payload };
    case userConstants.UPDATE_ORDER_TRACKING:
      return { ...state, tracking: { ...state.tracking, ...action.payload } };
    case userConstants.CONFIRM_DELIVERY:
      return {
        ...state,
        tracking: state.tracking
          ? {
              ...state.tracking,
              delivery_confirmed_by_buyer: true,
              tracking_status: "delivered",
            }
          : null,
      };
    default:
      return state;
  }
}
